<template>
  <BModal
    id="tracking-resi"
    hide-footer
    modal-class="modal-primary"
    centered
    hide-header
    size="lg"
  >
    <HistoryShipping
      :awb="awb"
      :expedition="data.shipping"
    >
      <template v-slot:footer>
        <p
          v-if="claimMessageData.message"
          :class="['text-center my-[8px]', claimMessageData.className]"
        >
          {{ claimMessageData.message }}
        </p>
      </template>
    </HistoryShipping>
  </BModal>
</template>

<script>
import HistoryShipping from '../../tiket/HistoryShipping.vue'

export default {
  components: {
    HistoryShipping,
  },
  props: {
    awb: {
      type: String,
      default: '',
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    isShowClaimMessage: false,
  }),
  computed: {
    claimMessageData() {
      const statusMap = {
        0: { message: 'Claim Sedang Direview', className: 'text-[#FBA63C]' },
        1: { message: 'Claim Disetujui', className: 'text-[#34A770]' },
        2: { message: 'Claim Ditolak', className: 'text-[#E31A1A]' },
      }
      return statusMap[this.data.status_claim_lost] || { message: '', className: '' }
    },
  },
}
</script>
